/**
 * Shopify redirects locked storefronts to /password with a plain 302,
 * before any theme code runs and without a `return_to` parameter. That
 * means the originally requested URL is lost by the time /password loads.
 *
 * To work around this, we remember the destination of internal link
 * clicks in sessionStorage *before* the browser navigates away. If that
 * navigation gets bounced to /password, the password page can read the
 * stored value back and redirect there after a successful login.
 */
(function () {
  const STORAGE_KEY = 'brita:return_to';

  const isInternalLink = (anchor) => {
    if (!anchor || !anchor.href) {
      return false;
    }
    if (anchor.target && anchor.target !== '_self') {
      return false;
    }
    if (anchor.hasAttribute('download')) {
      return false;
    }

    let url;
    try {
      url = new URL(anchor.href, window.location.href);
    } catch {
      return false;
    }

    if (url.origin !== window.location.origin) {
      return false;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return false;
    }

    return true;
  };

  document.addEventListener(
    'click',
    (event) => {
      const anchor = event.target.closest ? event.target.closest('a[href]') : null;
      if (!isInternalLink(anchor)) {
        return;
      }

      const url = new URL(anchor.href, window.location.href);
      if (url.pathname === '/password') {
        return;
      }

      try {
        window.sessionStorage.setItem(STORAGE_KEY, url.pathname + url.search);
      } catch {
        // sessionStorage unavailable (e.g. privacy mode) — nothing we can do.
      }
    },
    true
  );

  /**
   * Shopify's `storefront_password` form ignores the `return_to` parameter
   * and always redirects to the homepage after a successful unlock. As a
   * client-side fallback, once we land on the homepage right after coming
   * from the password page, immediately forward the visitor to the page
   * they originally wanted (stored above) instead of leaving them on "/".
   */
  const redirectAfterUnlock = () => {
    const isHomepage = window.location.pathname === '/';
    if (!isHomepage) {
      return;
    }

    let cameFromPassword = false;
    try {
      cameFromPassword = Boolean(document.referrer) && new URL(document.referrer).pathname === '/password';
    } catch {
      cameFromPassword = false;
    }
    if (!cameFromPassword) {
      return;
    }

    let target = null;
    try {
      target = window.sessionStorage.getItem(STORAGE_KEY);
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      target = null;
    }

    if (!window.BritaPasswordUtils?.isSafeReturnTo?.(target) || target === '/' || target === '/password') {
      return;
    }

    window.location.replace(target);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', redirectAfterUnlock);
  } else {
    redirectAfterUnlock();
  }
})();
